const yarppFooterLocation = document.querySelector(
    '[data-related-pages-location="footer"]'
);
const yarppSidebarLocation = document.querySelector(
    ".c-related-pages--sidebar"
);
const yarppRelatedPagesContent = yarppSidebarLocation?.innerHTML;

const startRelatedPages = () => {
    if (!yarppSidebarLocation || !yarppFooterLocation) {
        return;
    }

    wrapAsideContent();

    const mediaQuery = window.matchMedia("(max-width: 880px)");

    handleViewportChange(mediaQuery);

        if (typeof mediaQuery?.addEventListener === "function") {
            mediaQuery.addEventListener("change", handleViewportChange);
        } 
};

const handleViewportChange = e => {
    if (e.matches) {
        window.addEventListener("scroll", checkThreshold);
    } else {
        window.removeEventListener("scroll", checkThreshold);
    }
};

const checkThreshold = () => {
    const heroHeight = document.querySelector(".c-page__header")?.offsetHeight;
    const halfPageHeight =
        (document.querySelector(".l-page-wrapper").offsetHeight - heroHeight) /
        2;
    let scrollDistance = window.scrollY;
    let halfPagedReached = false;

    if (scrollDistance > halfPageHeight && !halfPagedReached) {
        halfPagedReached = true;
        moveRelatedToFooter();
    }

    if (scrollDistance <= halfPageHeight && halfPagedReached) {
        halfPagedReached = false;
        moveRelatedToSidebar();
    }
};

const moveRelatedToFooter = () => {
    yarppFooterLocation.innerHTML = yarppRelatedPagesContent;
    yarppSidebarLocation.innerHTML = "";
};

const moveRelatedToSidebar = () => {
    yarppFooterLocation.innerHTML = "";
    yarppSidebarLocation.innerHTML = yarppRelatedPagesContent;
};

const wrapAsideContent = () => {
    const asideElement = document.querySelector(".c-page__aside");
    const relatedSideBar = document.querySelector(".c-related");
    const sidebarCta = asideElement.querySelector(".c-cta");

    let newDivElement = document.createElement("div");
    // newDivElement.style.position = 'sticky';
    // newDivElement.style.top = '5rem';

    newDivElement.appendChild(relatedSideBar);
    newDivElement.appendChild(sidebarCta);

    asideElement.appendChild(newDivElement);
};

startRelatedPages();
